import { sanityClient } from 'src/boot/sanity'

export const homeQuery = `*[_type == "home"] {
  title,
  body,
  image {
    asset-> {
      url
    }
  },
}[0]`

export const queryHome = async () => {
  try {
    const result = await sanityClient.fetch(homeQuery)
    return result
  } catch (error) {
    console.error('Failed to execute queryHome', error)
    throw error
  }
}
